import toast, { ToastPosition } from 'react-hot-toast';
import { FiAlertTriangle } from 'react-icons/fi';
import { v4 as uuid } from 'uuid';

interface IWarningToastProps {
  duration?: number;
  position?: ToastPosition;
  toastMessage: string;
}

export function WarningToast({
  duration = 3000,
  position = 'top-right',
  toastMessage,
}: IWarningToastProps) {
  return toast(toastMessage, {
    id: uuid(),
    icon: <FiAlertTriangle className="min-w-fit" size={20} />,
    position,
    duration,
    style: {
      color: '#FFF',
      background: '#cfd52d',
      padding: '.75rem 1.25rem',
    },
  });
}
